import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-csv-version',
  templateUrl: './csv-version.component.html',
  styleUrls: ['./csv-version.component.scss']
})

export class CsvVersionComponent implements OnInit {

  constructor(private http:HttpClient) { }

  csvURL:String;
  csvResult: String;

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.getData();
  }

  getData():void {
    const url = `${environment.serverUrl}/api/status/csv-upload-date/`;

    this.csvURL = url;

    this.http.get(url).subscribe((data) => {
        this.csvResult = data.toString();
    });
  }
}
